import React from 'react';
import MasterScreenMain from "../../MasterScreenMain";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowTrendUp} from "@fortawesome/free-solid-svg-icons";
import ReportingSubMenu from "../../components/reporting/ui/ReportingSubMenu";

const CustomReportsScreen = (props) => {
    const {} = props;

    return (
        <MasterScreenMain selection="reporting">
            <div id="reporting-" className="pad">
                <h1>
                    <FontAwesomeIcon icon={faArrowTrendUp} />
                    Reporting
                </h1>

                <div className="details-body">
                    <ReportingSubMenu selection="custom" />

                    <div className="pad">
                        <h2>My Saved Reports</h2>

                        <p>
                            This is where you can create your own reports and save them for later.
                        </p>
                    </div>
                </div>
            </div>

        </MasterScreenMain>
    );
    
};

export default CustomReportsScreen;
